import { Theme, useMediaQuery } from '@mui/material'
import { ApiErrors, PartnerApiResponse, UploadGTMEvents } from '../types/widget'
import { useMemo } from 'react'
import useUser from '../hooks/useUser'
import { SessionAPIResponse } from '../components/Providers/UserSession'

export function isUploadSucess(
  code: PartnerApiResponse['status']['code'] | undefined,
  message?: string
): boolean {
  return (
    code === '200' ||
    code === '202' ||
    (code === '409' && message !== ApiErrors.DuplicateResume)
  )
}

export function toFormData(
  payload: Record<string, string | File>,
  initialPayload?: FormData
): FormData {
  return Object.entries(payload).reduce((formData, [key, value]) => {
    formData.append(key, value)
    return formData
  }, initialPayload ?? new FormData())
}

export function useWidgetQueries(): {
  isDesktop: boolean
} {
  const isDesktop = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up('tablet')
  )
  return useMemo(
    () => ({
      isDesktop,
    }),
    [isDesktop]
  )
}

export const widgetSessionUtils = {
  setUploadEventFired: (): void =>
    sessionStorage.setItem(UploadGTMEvents.ResumeUpload, 'yes'),
  isUploadEventFired: (): string | null =>
    sessionStorage.getItem(UploadGTMEvents.ResumeUpload),
}

type GTMPayloadType = Partial<
  Pick<
    SessionAPIResponse,
    'hashedEmail' | 'userLeadAge' | 'userLeadScore' | 'partnerId'
  >
> & {
  userId?: SessionAPIResponse['lead_auth_token']
  blogCategory: 'All'
}

export function useResumeUploadGTMPayload(): GTMPayloadType {
  const {
    hashedEmail,
    userLeadAge,
    userLeadScore,
    partnerId,
    lead_auth_token: leadAuthToken,
  } = useUser()

  return useMemo(
    () =>
      ({
        hashedEmail,
        userLeadAge,
        userLeadScore,
        partnerId,
        userId: leadAuthToken,
        blogCategory: 'All',
      } satisfies GTMPayloadType),
    [hashedEmail, userLeadAge, userLeadScore, partnerId, leadAuthToken]
  )
}
